export default {
  TITLE: 250,
  NAME: 250,
  CATEGORY: 180,
  CREATED_AT: 150,
  USER: 100
}
